
    import {
        defineComponent, PropType, computed, toRefs, unref,
    } from 'vue';
    import { formatNumber } from '@ve/services/textModifiers';
    import { CancellationPolicyGroupHotelOffer } from '@ve/types/api/CancellationPolicyGroupHotelOffer';

    import convertDateTime from './service/convertDateTime';

    export default defineComponent({
        name: 'cancellation-policy-description',
        props: {
            cancellationPolicy: {
                type: Object as PropType<CancellationPolicyGroupHotelOffer>,
                required: true,
            },
        },
        setup(props) {
            const { cancellationPolicy } = toRefs(props);
            const modifiedPolicies = computed(() => unref(cancellationPolicy).policies.map((policy, index) => ({
                ...policy,
                dateUntil: policy.dateBefore,
                dateBefore: unref(cancellationPolicy).policies[index - 1]?.dateBefore || unref(cancellationPolicy).freeCancellationDateBefore || null,
            })));

            return {
                formatNumber,
                modifiedPolicies,
                convertDateTime,
            };
        },
    });
